import { Skeleton as ShadcnSkeleton } from '@/components/ui/skeleton';

export function SkeletonCard() {
  return (
    <div className="p-4 border-b border-border">
      <div className="flex items-start gap-2 mb-2">
        <ShadcnSkeleton className="h-5 w-16" />
        <ShadcnSkeleton className="h-5 w-20" />
      </div>
      <ShadcnSkeleton className="h-5 w-3/4 mb-2" />
      <ShadcnSkeleton className="h-4 w-full" />
    </div>
  );
}

export function SkeletonList({ count = 5 }: { count?: number }) {
  return (
    <div className="divide-y divide-border">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export function SkeletonText({ lines = 3 }: { lines?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: lines }).map((_, i) => (
        <ShadcnSkeleton
          key={i}
          className="h-4"
          style={{ width: i === lines - 1 ? '60%' : '100%' }}
        />
      ))}
    </div>
  );
}
